import React, { PropsWithChildren } from 'react';
import { CheckBox as AuraCheckbox, ProColors } from '@treatwell/treatwell-aura';
import { css } from '@emotion/react';
import { useValidator } from '../helpers/use-validation';
import { FormContextData } from '../../../state';

export type CheckboxProps = PropsWithChildren & {
  validate: (data: FormContextData) => string | null;
  checked: boolean;
  onChange: (value: boolean) => void;
};

export function ForcedCheckbox({
  children,
  checked,
  onChange,
  validate,
}: CheckboxProps): JSX.Element {
  const wasValidated = useValidator(validate);

  return (
    <AuraCheckbox
      checked={checked}
      onChange={onChange}
      css={css({
        '.aura--checkbox-empty': {
          ...(wasValidated && !checked
            ? { borderColor: ProColors.coral[600] }
            : {}),
        },
      })}
    >
      <span
        className="aura--copy-sm"
        css={css({
          color:
            wasValidated && !checked
              ? ProColors.coral[600]
              : ProColors.navy[800],
          fontWeight: 400,
          whiteSpace: 'pre-wrap',
        })}
      >
        {children}
      </span>
    </AuraCheckbox>
  );
}
